export const closedTestingSelector = (state) => ({ closedTesting: state.closedTesting });

export default () => true;
